var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10465 13.8473V11.8028C5.10464 11.2828 5.52858 10.8602 6.05385 10.8567H7.9779C8.50567 10.8567 8.93351 11.2803 8.93351 11.8028V11.8028V13.8536C8.93338 14.2951 9.28934 14.656 9.7352 14.6663H11.0179C12.2966 14.6663 13.3332 13.6401 13.3332 12.3742V12.3742V6.55823C13.3263 6.06023 13.0902 5.59257 12.6918 5.28836L8.30498 1.78988C7.53646 1.18072 6.44397 1.18072 5.67545 1.78988L1.30785 5.29471C0.90801 5.59769 0.671428 6.06612 0.666504 6.56458V12.3742C0.666504 13.6401 1.70309 14.6663 2.98178 14.6663H4.26448C4.72141 14.6663 5.09182 14.2996 5.09182 13.8473V13.8473",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenu);
export default __webpack_public_path__ + "static/media/homeMenu.6c30a740ac2a512d944d09eb806a0a15.svg";
export { ForwardRef as ReactComponent };